<template>
  <div class="mod-config" style="height: 100%">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item style="float: right;">
        <el-dropdown placement="bottom" trigger="click" style="margin-left: 10px;">
          <el-button style="font-size: 16px;">更多</el-button>
          <el-dropdown-menu slot="dropdown" style="margin-top:4px;width: 110px;text-align: center;">
            <el-dropdown-item>
              <router-link title="设备记录" :to="{path:'/indexhome/reminderRecord'}" replace>
                提醒记录
              </router-link>
            </el-dropdown-item>
            <!--            <el-dropdown-item><span>充值记录</span></el-dropdown-item>-->
          </el-dropdown-menu>
        </el-dropdown>
      </el-form-item>
      <el-form-item style="float: left;" label="物联网卡号：">
        <el-input v-model="dataForm.msisdn" placeholder="请输入SIM卡号" clearable></el-input>
      </el-form-item>
      <el-button @click="search()" type="primary" icon="el-icon-search" style="float: left;"></el-button>
      <el-form-item style="float: right;">
        <el-button @click="addOrUpdateHandle()" type="primary" v-if="isAuth('sim:save')">添加卡号</el-button>
        <!--        <el-button @click="addOrUpdateHandle()" type="primary">添加卡号</el-button>-->
        <el-button type="success" @click="queryAll">查询所有</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="dataList" border v-loading="dataListLoading" @selection-change="selectionChangeHandle"
      style="width: 100%;" height="calc(100% - 120px)" border stripe :header-cell-style="{background:'#FAFAFA'}"
      placement="top">
      <el-table-column prop="msisdn" header-align="center" align="center" label="卡号">
      </el-table-column>
      <el-table-column prop="deviceName" header-align="center" align="center" label="绑定设备">
      </el-table-column>
      <el-table-column prop="cardType" header-align="center" align="center" label="物联网卡厂商" v-if="isAuth('simWk:show')">
        <template slot-scope="scope">
          <label v-if="scope.row.cardType == 0">
            华商物联
          </label>
          <label v-if="scope.row.cardType == 1">
            齐犇物联
          </label>
        </template>
      </el-table-column>
      <el-table-column prop="status" header-align="center" align="center" label="激活状态">
        <template slot-scope="scope">
          <label v-if="scope.row.cardType == '1'&& scope.row.cardType == 0">
            待激活
          </label>
          <label v-if="scope.row.cardStatus == '2'&& scope.row.cardType == 0">
            已激活
          </label>
          <label v-if="scope.row.cardStatus == '4'&& scope.row.cardType == 0">
            停机
          </label>
          <label v-if="scope.row.cardStatus == '6'&& scope.row.cardType == 0">
            可测试
          </label>
          <label v-if="scope.row.cardStatus == '7'&& scope.row.cardType == 0">
            库存
          </label>
          <label v-if="scope.row.cardStatus == '8'&& scope.row.cardType == 0">
            预销户
          </label>
          <label v-if="scope.row.cardStatus == '9'&& scope.row.cardType == 0">
            已注销
          </label>

          <label v-if="scope.row.cardType == '1'&& scope.row.cardType == 1">
            正常
          </label>
          <label v-if="scope.row.cardType == '2'&& scope.row.cardType == 1">
            停机
          </label>
          <label v-if="scope.row.cardType == '3'&& scope.row.cardType == 1">
            待激活
          </label>
        </template>
      </el-table-column>
      <el-table-column prop="remain" header-align="center" align="center" label="剩余流量(M)">
      </el-table-column>
      <el-table-column prop="openDate" header-align="center" align="center" label="激活日期">
      </el-table-column>
      <el-table-column prop="endTime" header-align="center" align="center" label="到期日期">
      </el-table-column>
      <el-table-column header-align="center" width="150" align="center" label="操作">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="查询" placement="top">
            <el-button type="text" style="font-size: 18px;padding: 0;" @click="query(scope.row.id)"><i
                class="el-icon-refresh-left"></i></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <el-button type="text" style="font-size: 18px;padding: 0;" @click="deleteHandle(scope.row.id)"
              v-if="isAuth('sim:delete')"><i class="el-icon-delete" v-if="isAuth('sim:delete')"></i>
            </el-button>
          </el-tooltip>
          <!--          <el-tooltip class="item" effect="dark" content="充值" placement="top">-->
          <!--            <el-button type="text" style="font-size: 18px;"  @click="addOrUpdateHandle(scope.row.id)"><i-->
          <!--                    class="el-icon-user"></i>充值</el-button>-->
          <!--          </el-tooltip>-->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
      layout="prev, pager, next, jumper, total,sizes">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </div>
</template>
<script>
import AddOrUpdate from "./sim-add-or-update";
import { isAuth } from "@/utils";
export default {
  data() {
    return {
      dataForm: {
        params: ""
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      addOrd: ""
    };
  },
  components: {
    AddOrUpdate
  },
  created() {
    this.getDataList();
  },
  methods: {
    search() {
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      this.$http({
        url: this.$http.adornUrl("/sim/getSimInfo"),
        method: "get",
        params: this.$http.adornParams({
          pageNum: this.pageIndex,
          pageSize: this.pageSize,
          msisdn: this.dataForm.msisdn
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.dataList = data.data.rows;
          this.totalPage = data.data.total;
        } else {
          this.dataList = [];
          this.totalPage = 0;
          this.$message.error(data.msg);
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    //
    query(id) {
      this.$http({
        url: this.$http.adornUrl("sim/select/" + id),
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.$message({
            message: data.msg,
            type: "success",
            duration: 1000
          });
          this.getDataList();
        } else {
        }
      });
    },
    //
    queryAll() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$http({
        url: this.$http.adornUrl("sim/getSimAll"),
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.$message({
            message: data.msg,
            type: "success",
            duration: 1000
          });
          this.getDataList();
          loading.close();
        } else {
        }
      });
    },
    deleteHandle(id) {
      let ids = id
        ? [id]
        : this.dataListSelections.map(item => {
            return item.id;
          });
      this.$confirm(
        `确定对[id=${ids.join(",")}]进行[${id ? "删除" : "批量删除"}]操作?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        this.$http({
          url: this.$http.adornUrl("sim/delete"),
          method: "post",
          data: this.$http.adornData(ids, false)
        }).then(({ data }) => {
          if (data && data.code === 200) {
            this.getDataList();
            this.$message({
              message: data.msg,
              type: "success",
              duration: 1000
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },
    // 权限
    isAuth(key) {
      return isAuth(key);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admincenter/sim_management.vue